import React, { useEffect, useState } from "react";
import Card from "../Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../DatePicker/helpers";

const TextCard = (props: any) => {
  const {
    title,
    count,
    amount,
    slug,
    setSelecteddPaymentMethod,
    selectedPaymentMethod,
  } = props;

  return (
    <Card
      onClick={() => {
        {
          slug === selectedPaymentMethod
            ? setSelecteddPaymentMethod(null)
            : setSelecteddPaymentMethod(slug);
        }
      }}
    >
      <div
        className={classNames(
          slug === selectedPaymentMethod
            ? tw`bg-primary-active text-primary  `
            : tw``,
          tw`rounded-md h-full flex flex-col justify-between`
        )}
      >
        <div
          className={tw`uppercase text-primary  font-semibold cursor-pointer mx-2 pt-2`}
        >
          {title}
        </div>
        <div
          className={tw`flex flex-wrap w-full justify-between mx-auto mt-4 pr-2 cursor-pointer px-2 pb-2`}
        >
          <div className={tw`font-medium text-lg`}>{count}</div>
          <div className={tw`font-medium text-xl`}>Rs.{amount}</div>
        </div>
      </div>
    </Card>
  );
};

export default TextCard;
